(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-siblings"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.product-siblings__option:not([data-sb-init])').forEach(function (option) {
    option.dataset.sbInit = '1';
    var label = option.querySelector('[ref="siblingLabel"]');
    if (!label) return;
    var defaultText = label.textContent;
    option.querySelectorAll('.product-siblings__swatch').forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        label.textContent = link.dataset.siblingLabel || defaultText;
      });
      link.addEventListener('mouseleave', function () {
        label.textContent = defaultText;
      });
    });
  });
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text-expandable"] && !Shopify.designMode) return;
  try {
    (function () {
  function init() {
    document.querySelectorAll('.text-expandable:not([data-rm])').forEach(function (el) {
      el.dataset.rm = '1';
      var inner = el.querySelector('.text-expandable__inner');
      var btn   = el.querySelector('.text-expandable__btn');
      if (!inner || !btn) return;
      if (inner.scrollHeight <= inner.clientHeight + 2) {
        btn.hidden = true;
        return;
      }
      btn.addEventListener('click', function () {
        var expanded = el.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Læs mindre' : 'Læs mere';
        btn.setAttribute('aria-expanded', expanded);
      });
    });
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
}());
  } catch(e) { console.error(e); }
})();

})();
